import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { VehicleTemplateEntity } from '../../domain/entities/VehicleTemplateEntity'
import type { VehicleTemplateDto } from '@/backend/market'

export class VehicleTemplateModel extends VehicleTemplateEntity {
  constructor(dataDto: VehicleTemplateDto) {
    super()
    mapEntityProperties<VehicleTemplateEntity>(this, dataDto)
  }
}
